import { Component } from '@angular/core';
import { NavParams, PopoverController, ModalController, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { NavUrls } from '../../../enums/nav-urls';
import { MachineV2Dto, MachineRestService, ExaAdapterRestService } from '../../../api/exa';
import { AlertService, AlertDialogButtonClick } from '../../../services/alert.service';
import { MachineService } from '../../../services/machine.service';
import { TranslateService } from '@ngx-translate/core';
import { ExaAdapterService } from 'src/app/services/exa-adapter.service';

@Component({
  selector: '',
  templateUrl: './machine-context-menu.component.html',
  styleUrls: ['../popover.component.scss'],
})
export class MachineContextMenuComponent {
  machineDto: MachineV2Dto;

  machineId: number;

  hasGrantToWriteMachine: boolean;

  adapters = null;
  temp_adapters = [];
  selectedAdapter = null;

  constructor(
    private navParams: NavParams,
    private router: Router,
    protected popoverController: PopoverController,
    private alertService: AlertService,
    private machineService: MachineService,
    private machineRestService: MachineRestService,
    private translate: TranslateService,
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private adapterService: ExaAdapterService,
    private adapterRestService: ExaAdapterRestService
  ) {
    this.adapterService.onGetAdapters().subscribe((adap) => {
      this.adapters = adap;
      this.temp_adapters = this.adapters;      
    });

    this.machineDto = this.navParams.data.machineDto;
    this.machineId = this.machineDto.id;

    this.hasGrantToWriteMachine = this.navParams.data.hasGrantToWriteMachine;
  }

  // =================================== BUTTONS =================================

  onClickEdit() {
    let editMachineUrl = NavUrls.MACHINES + '/' + NavUrls.ADDMACHINE + '/' + this.machineId;
    this.router.navigateByUrl(editMachineUrl);
    this.popoverController.dismiss();
  }

  onClickDelete() {
    this.onClickDeleteMachine(this.machineId);
  }

  onClickActivate() {
    this.machineDto.active = true;
    this.machineRestService.updateMachineUsingPUT(this.machineId, this.machineDto).subscribe((ret) => {
      console.log(' return: ', ret);
    }),
      (err) => {
        console.log(' ERROR: ', err);
      };
    this.popoverController.dismiss('activated');
  }

  onClickDeactivate() {
    this.machineDto.active = false;
    this.machineRestService.updateMachineUsingPUT(this.machineId, this.machineDto).subscribe((ret) => {
      console.log(' return: ', ret);
    }),
      (err) => {
        console.log(' ERROR: ', err);
      };
    this.popoverController.dismiss('deactivated');
  }

  onSearch(e) {
    const query = e.detail.value.toLowerCase();
    this.adapters = this.temp_adapters.filter((d) => d.serial?.toLowerCase().indexOf(query) > -1);
  }

  onClickDeleteMachine(machineId: number) {
    this.alertService
      .presentConfirmAlert(this.translate.instant('WARNING'), this.translate.instant('MACHINE.DELETE.QUESTION'))
      .then((buttonClick) => {
        if (buttonClick == AlertDialogButtonClick.OK) {
          console.log(' User hat Löschung bestätigt');
          this.machineService.deleteMachine(machineId).finally(() => {
            // egal was passiert das popover schliesst sich
            // Suchfilter zuruecksetzen in der machines.ts
            this.popoverController.dismiss();
          });
        }
      });
  }
  // =================================== MISC =================================

  selectAdapter(adapterMAC) {    
    this.adapterRestService.assignToMachineByMacUsingPOST(adapterMAC, this.machineId).subscribe((data) => {
      this.onSelectedAdapter();
    });
    this.popoverController.dismiss();
    this.modalCtrl.dismiss();
    this.adapters = this.temp_adapters;
    this.toastController
      .create({
        message: this.translate.instant('ADAPTER.ASSIGN.SUCCESS'),
        duration: 5000,
      })
      .then((toast) => {
        toast.present();
      });
  }

  onSelectedAdapter() {
    this.machineService.reloadMachines();
    this.adapterService.reloadAdapters();
  }
}
